import React, { Component } from "react";
import { Fragment, useState } from "react";
import axios from "axios";
import { CheckCircleIcon, XIcon } from "@heroicons/react/solid";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { Navigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import mainLogo from "../mglogo.png";
class Emailverification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showmsg: false,
      redirect: false,
      emailverificationCode: "",
      token: "",
      success: false,
      error_list: [],
    };
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  async componentDidMount() {
    alert();
    const { id } = this.props.params;
    this.setState({ emailverificationCode: id });
    console.log(id);
    console.log(this.state.emailverificationCode);
    const res = await axios.get(
      "public/api/emailverification/" + id,
      this.state
    );

    if (res.data.success) {
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.setState({ error_list: res.data.data });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
            This example requires updating your template:
    
            ```
            <html class="h-full bg-gray-50">
            <body class="h-full">
            ```
          */}

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Email Id verified
                      </p>
                      <p className="mt-1 text-sm text-gray-500">
                        Login your Account
                      </p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}
export default (props) => <Emailverification {...props} params={useParams()} />;
